module.exports = __webpack_public_path__ + "img/nfc-lock.7da46f14.svg";